import React from "react";
import { Box } from "@mui/material";

import PreChatHeader from "../ui/PreChatHeader";
import PreChatContainer from "../ui/PreChatContainer";
import InfoCardGrid from "../ui/InfoCardGrid";
import InfoCard from "../ui/InfoCard";
import BulletList from "../ui/BulletList";
import Column from "../ui/core/Column";
import ChatInput from "../chat/components/ChatInput";
import { channelsConfig } from "../../config/channels";
import { ClaimReviewIcon } from "../icons/ClaimReviewIcon";

const AppealAClaim: React.FC = () => {
  const helpItems = [
    "Denial analysis and appeal strategy",
    "Medical necessity and policy alignment",
    "Evidence gathering and citation suggestions",
    "Recommended corrections and documentation",
    "Draft points for the appeal submission",
  ];

  const appealScenarios = [
    '"Medical necessity not established"',
    '"Incorrect or missing modifier"',
    '"Prior authorization not found"',
    '"Out of network / coverage exclusion"',
    '"Coding mismatch or diagnosis conflict"',
  ];

  return (
    <main className="grow flex flex-row bg-hex-gray-100 h-[calc(100%-6rem)]">
      <Column
        sx={{
          height: "100%",
          width: "100%",
          minWidth: 0,
          minHeight: 0,
          overflow: "hidden",
          justifyContent: "flex-start",
          alignItems: "stretch",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: { xs: 1.5, sm: 2 },
            pb: { xs: 1, sm: 1.5 },
            boxSizing: "border-box",
          }}
        >
          <PreChatContainer containerClassName="min-w-0">
            <PreChatHeader
              icon={<ClaimReviewIcon />}
              iconAlt="Appeal a Claim"
              title="Appeal a Claim"
              description="Please provide your denial documentation by attaching the Original claim document and the Rejection notice/EOB using the paperclip icon in the chatbox below or drag & drop them here."
            />

            <InfoCardGrid>
              <InfoCard title="I will help you with:">
                <BulletList items={helpItems} />
              </InfoCard>
              <InfoCard title="Examples of appeal scenarios:">
                <BulletList items={appealScenarios} />
              </InfoCard>
            </InfoCardGrid>
          </PreChatContainer>
        </Box>

        <ChatInput
          requiredInputs={channelsConfig["appeal-claim"].requiredInputs}
        />
      </Column>
    </main>
  );
};

export default AppealAClaim;
